import { safeUrl, validateContent } from "../../../Core/Content/validation.mjs";
import { MenuItem, PageContent, PageId } from "../../../Core/Content/Types";
export function isDirtyFn(
  content: PageContent,
  baseline: PageContent
): boolean {
  return JSON.stringify(content) !== JSON.stringify(baseline);
}
export function safeUrlFn(value: string): boolean {
  return safeUrl(value);
}
export function validatePageFn(content: PageContent, pageId: PageId): string[] {
  return validateContent(pageId, content);
}
export function newItemFn(id: string): MenuItem {
  return {
    id,
    title: "",
    description: "",
    subtitle: "",
    img: "",
    alt: "",
    price: "",
    link: "",
    visible: false,
    includes: [],
  };
}
export function moveItemFn<T>(
  items: T[],
  index: number,
  direction: number
): T[] {
  const result = [...items];
  const target = index + direction;
  if (target >= 0 && target < result.length)
    [result[index], result[target]] = [result[target], result[index]];
  return result;
}
